import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { IResponseLive } from '../../../../services/api/models/response/responseLive';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import scoreIcon from '../../../../assets/svg/score.svg';
import circleAcceptPair from '../../../../assets/svg/bosyuu1_frame.svg';
import './LiveBlock.scss';
import { AppState } from '../../../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import {
  toggleLiveMatchList,
  toggleLiveMatchLiverModal,
  updateUserRequestMatch,
} from '../../../live-match/liveMatchSlice';
import MarkIconVS from '../../../../assets/svg/mark_vs.svg';
import MarkIconCollab from '../../../../assets/svg/mark_collab.svg';
import { LiveMatchKindType } from '../../../live-match/types/LiveMatchTypes';

interface LiveBlockProps {
  live: IResponseLive;
}

export const LiveBlock = (props: LiveBlockProps): ReactElement => {
  const { live } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const profileUserId = useSelector(
    (state: AppState) => state.profilePageState.userData?.user.id,
  );
  const isShowLiveMatchLiver = useSelector(
    (state: AppState) => state.liveMatch.isShowLiveMatchLiver,
  );
  const enterLive = () => {
    // logic for host when host click
    if (isShowLiveMatchLiver) {
      dispatch(updateUserRequestMatch(live));
      dispatch(toggleLiveMatchLiverModal(false));
    } else {
      if (live.kind === 'radio') {
        history.push(`/voice/${live.liveId}`);
      } else {
        history.push(`/live/${live.liveId}`);
        dispatch(toggleLiveMatchList(false));
      }
    }
  };

  return (
    <>
      {live.userId !== profileUserId && (
        <div className="live-block" onClick={enterLive}>
          <ImageCustom className="live-block__bg" src={live.userPictureUri} />
          <div className="live-block__content">
            <div className="live-block__content__label">
              <ImageCustom
                className="live-block__content__score__ico"
                src={scoreIcon}
                style={{ marginRight: '5' }}
              />
              {live.score?.toLocaleString()}
              {' | '}
              {live.liveCategoryName}
            </div>
            <div className="live-block__content__name">{live.userLoginId}</div>
          </div>
          {live.kind === 'radio' && (
            <div className="live-block_pair-guest">
              {live.pairUserPictureUri ? (
                <ImageCustom
                  className="pair-guest__icon-img"
                  style={{ borderRadius: '50%', width: '100%' }}
                  src={live.pairUserPictureUri}
                />
              ) : (
                <ImageCustom
                  className="pair-guest__icon-btn"
                  src={circleAcceptPair}
                />
              )}
            </div>
          )}
          {live.matchKind && (
            <div className="live-block_pair-guest">
              <ImageCustom
                className="pair-guest__icon-img"
                style={{ borderRadius: '50%', width: '100%' }}
                src={live.matchUserPictureUri}
              />
              <ImageCustom
                className="pair-guest__icon-mark"
                src={
                  live.matchKind === LiveMatchKindType.VS
                    ? MarkIconVS
                    : MarkIconCollab
                }
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};
